import React from 'react';
import { useIntl } from 'react-intl-next';
import { GoogleIcon } from './images/google';
import { MicrosoftIcon } from './images/microsoft';
import { SlackIcon } from './images/slack';
import { messages } from '../i18n';
import { GOOGLE_SERVICE, MICROSOFT_SERVICE, PLATFORM_SLACK_SERVICE } from './constants';
import { type Integration } from '../../types';

const ICON_HEIGHT = 16;
const ICON_WIDTH = ICON_HEIGHT;

export const useIntegrationComponents = (integration: Integration) => {
	const { formatMessage } = useIntl();

	let icon: JSX.Element | null = null;
	let connectButtonText: string | null = null;
	let toolTip: string | null = null;

	switch (integration) {
		case PLATFORM_SLACK_SERVICE:
			icon = <SlackIcon height={ICON_HEIGHT} width={ICON_WIDTH} key={integration} />;
			connectButtonText = formatMessage(messages.slackThirdPartyButton);
			toolTip = formatMessage(messages.slackThirdPartyConnectedTooltip);
			break;
		case GOOGLE_SERVICE:
			icon = <GoogleIcon height={ICON_HEIGHT} width={ICON_WIDTH} key={integration} />;
			connectButtonText = formatMessage(messages.googleThirdPartyButton);
			toolTip = formatMessage(messages.googleThirdPartyConnectedTooltip);
			break;
		case MICROSOFT_SERVICE:
			icon = <MicrosoftIcon height={ICON_HEIGHT} width={ICON_WIDTH} key={integration} />;
			connectButtonText = formatMessage(messages.microsoftThirdPartyButton);
			toolTip = formatMessage(messages.microsoftThirdPartyConnectedTooltip);
			break;
	}
	return {
		icon,
		connectButtonText,
		toolTip,
	};
};
